'use client';

import { CompanyContext } from '@/_contexts/admin/CompanyProvider';
import { Dialog, UpdateOwnersDialog } from '@/_components';
import { NewOwnerForm } from './_components/NewOwnerForm';
import { SelectNewOwner } from './_components/SelectNewOwner';
import { useState, useContext, useEffect, type FC } from 'react';
import type { CreateOwnerDialogProps } from './CreateOwnerDialog.types';
import type { User } from '@/_types/models/user';

export const CreateOwnerDialog: FC<CreateOwnerDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const [isCreating, setCreating] = useState<boolean>(false);
  const [newOwners, setNewOwners] = useState<Array<User>>([]);

  const { selectedCompany, setSelectedUser } = useContext(CompanyContext);

  useEffect(() => {
    if (!isOpen) {
      setSelectedUser(undefined);
      setCreating(false);
    }
  }, [isOpen, setSelectedUser]);

  const onNewEntity = () => setCreating(true);

  const onCloseUpdatingOwners = () => {
    setNewOwners([]);
    onClose();
  };

  return (
    <>
      <UpdateOwnersDialog
        isOpen={!!newOwners?.length}
        newOwners={newOwners}
        onClose={onCloseUpdatingOwners}
      />
      <Dialog
        isOpen={isOpen}
        isNarrow={false}
        isOverflowing={true}
        onClose={onCloseUpdatingOwners}
        title={
          isCreating
            ? `Create new User for ${selectedCompany?.name}`
            : 'Select User to add as Owner'
        }
      >
        <Dialog.Content>
          {isCreating ? (
            <NewOwnerForm
              setNewOwners={setNewOwners}
              onClose={onCloseUpdatingOwners}
            />
          ) : (
            <SelectNewOwner
              onNewEntity={onNewEntity}
              setNewOwners={setNewOwners}
            />
          )}
        </Dialog.Content>
      </Dialog>
    </>
  );
};
